import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "https://public.readdy.ai/ai/img_res/40fb9c56b1fca85b082fafe84b4013c9.jpg",
      title: "Réduisez votre facture d'énergie",
      subtitle: "jusqu'à 70%",
      desc: "Pompes à chaleur, panneaux solaires et solutions sur-mesure pour votre maison."
    },
    {
      image: "https://readdy.ai/api/search-image?query=Professional%20technician%20installing%20heat%20pump%20outside%20modern%20residential%20house%2C%20clean%20white%20unit%2C%20bright%20daylight%2C%20green%20garden%20background%2C%20warm%20tones%2C%20photorealistic&width=1920&height=1080&seq=hero-slide-2&orientation=landscape",
      title: "Chauffez votre maison",
      subtitle: "sans gaz ni fioul",
      desc: "Pompes à chaleur air/eau performantes, adaptées à tous types de logements."
    },
    {
      image: "https://readdy.ai/api/search-image?query=Beautiful%20rooftop%20solar%20photovoltaic%20panel%20installation%20on%20French%20house%2C%20blue%20sky%20with%20soft%20clouds%2C%20sunlight%20reflecting%20panels%2C%20warm%20afternoon%20light%2C%20residential%20neighborhood%2C%20high%20quality%20real%20estate%20photography&width=1920&height=1080&seq=hero-slide-3&orientation=landscape",
      title: "Produisez votre propre",
      subtitle: "électricité verte",
      desc: "Panneaux photovoltaïques avec batteries de stockage pour une autonomie totale."
    }
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const t = setInterval(() => setCurrentSlide(p => (p + 1) % slides.length), 6000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="relative min-h-screen flex flex-col">
      {/* Background slides */}
      <div className="absolute inset-0 overflow-hidden">
        {slides.map((s, i) => (
          <div
            key={i}
            className={`absolute inset-0 transition-opacity duration-1500 ${i === currentSlide ? 'opacity-100' : 'opacity-0'}`}
            style={{ transitionDuration: '1.5s' }}
          >
            <div className="w-full h-full bg-cover bg-center" style={{ backgroundImage: `url('${s.image}')` }}>
              <div className="absolute inset-0 bg-gradient-to-r from-slate-950/90 via-slate-900/70 to-slate-900/30"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Navbar */}
      <nav className={`relative z-30 transition-all duration-300 ${scrolled ? 'bg-white shadow-md fixed top-0 left-0 right-0' : 'bg-transparent'}`}>
        <div className="px-4 sm:px-8 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <img
              src="https://static.readdy.ai/image/2d70788572f3bf6ab3fc4009e4756eb5/7f9ed3602ae8058bafa044d085fa2086.png"
              alt="AIRPURE"
              className="h-12 w-auto"
            />

            <div className="hidden lg:flex items-center gap-8">
              {[
                { label: 'Nos Solutions', href: '#solutions' },
                { label: 'Aides de l\'État', href: '#aides' },
                { label: 'Pourquoi AIRPURE', href: '#pourquoi' },
                { label: 'Contrats d\'entretien', href: '/contrat-entretien' },
                { label: 'Contact', href: '#contact' },
              ].map(link => (
                <a
                  key={link.label}
                  href={link.href}
                  className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${scrolled ? 'text-slate-700 hover:text-orange-600' : 'text-white/90 hover:text-white'}`}
                >
                  {link.label}
                </a>
              ))}
            </div>

            <div className="hidden lg:flex items-center gap-3">
              <div className="text-right">
                <p className={`text-xs ${scrolled ? 'text-slate-500' : 'text-white/70'}`}>Appel gratuit</p>
                <p className={`text-base font-bold ${scrolled ? 'text-slate-800' : 'text-white'}`}>01 89 29 33 23</p>
              </div>
              <a
                href="tel:0189293323"
                className="w-10 h-10 bg-orange-500 hover:bg-orange-600 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-white text-lg"></i>
              </a>
              <a
                href="#contact"
                className="bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                Devis gratuit
              </a>
            </div>

            <button className="lg:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)}>
              <i className={`text-2xl ${scrolled ? 'text-slate-800' : 'text-white'} ${isMenuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
            </button>
          </div>

          {isMenuOpen && (
            <div className="lg:hidden bg-white border-t border-slate-100 py-4 rounded-b-2xl shadow-xl">
              {[
                { label: 'Nos Solutions', href: '#solutions' },
                { label: 'Pourquoi AIRPURE', href: '#pourquoi' },
                { label: 'Contrats d\'entretien', href: '/contrat-entretien' },
                { label: 'Aides de l\'État', href: '#aides' },
                { label: 'Contact', href: '#contact' },
              ].map(link => (
                <a key={link.label} href={link.href} className="block px-6 py-3 text-slate-700 hover:text-orange-600 font-medium cursor-pointer">
                  {link.label}
                </a>
              ))}
              <div className="px-6 pt-4 pb-2">
                <a href="tel:0189293323" className="flex items-center gap-3 bg-orange-500 text-white px-5 py-3 rounded-full font-semibold justify-center cursor-pointer">
                  <i className="ri-phone-line"></i> 01 89 29 33 23
                </a>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero content */}
      <div className="relative z-10 flex-1 flex items-center">
        <div className="px-4 sm:px-8 lg:px-16 w-full pt-8 pb-24">
          <div className="max-w-2xl">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-400/40 text-orange-300 text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
              <i className="ri-leaf-line"></i>
              Expert Énergie Verte RGE certifié
            </div>

            <h1 className="text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-3">
              {slides[currentSlide].title}
            </h1>
            <p className="text-5xl lg:text-6xl font-extrabold text-orange-400 leading-tight mb-6">
              {slides[currentSlide].subtitle}
            </p>
            <p className="text-lg text-white/80 mb-10 leading-relaxed max-w-xl">
              {slides[currentSlide].desc}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <a
                href="#contact"
                className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 text-center cursor-pointer whitespace-nowrap inline-block"
              >
                Devis gratuit en 2 min
              </a>
              <a
                href="tel:0189293323"
                className="border-2 border-white/60 hover:border-white text-white hover:bg-white/10 font-semibold text-lg px-8 py-4 rounded-full transition-all duration-300 text-center cursor-pointer whitespace-nowrap inline-block"
              >
                <i className="ri-phone-line mr-2"></i>01 89 29 33 23
              </a>
            </div>

            {/* Trust bar */}
            <div className="flex flex-wrap items-center gap-6">
              {[
                { icon: 'ri-shield-check-line', text: 'Certifié RGE' },
                { icon: 'ri-money-euro-circle-line', text: 'MaPrimeRénov\'' },
                { icon: 'ri-thumb-up-line', text: '+10 000 clients' },
                { icon: 'ri-star-fill', text: '4.9/5 avis clients' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2 text-white/80 text-sm">
                  <i className={`${item.icon} text-orange-400 text-base`}></i>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Logo watermark on images */}
      <div className="absolute bottom-24 right-8 z-10 hidden lg:flex items-center gap-2 bg-black/30 backdrop-blur-sm rounded-xl px-4 py-2.5">
        <img
          src="https://static.readdy.ai/image/2d70788572f3bf6ab3fc4009e4756eb5/7f9ed3602ae8058bafa044d085fa2086.png"
          alt="AIRPURE"
          className="h-7 w-auto opacity-90"
        />
        <span className="text-white/70 text-xs font-medium">air-pure-groupe.fr</span>
      </div>

      {/* Slide dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex gap-2">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentSlide(i)}
            className={`transition-all duration-300 rounded-full ${i === currentSlide ? 'w-8 h-2.5 bg-orange-400' : 'w-2.5 h-2.5 bg-white/40 hover:bg-white/60'}`}
          />
        ))}
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 right-8 z-10 text-white/50 animate-bounce hidden lg:block">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </div>
  );
}
